'use client';

import { useState } from 'react';
import { UseFormRegisterReturn, FieldValues, Path } from 'react-hook-form';

import { InputProps } from './types';

import { classNames } from '@/shared/lib/classNames/classNames';

export const Input = <T extends FieldValues>({
  label,
  id = label,
  error,
  watch,
  className,
  ...inputProps
}: InputProps<T> & UseFormRegisterReturn) => {
  const [isFocused, setIsFocused] = useState(false);
  const value = watch(inputProps.name as Path<T>);

  return (
    <div className={classNames({ cls: 'w-[400px]', additional: [className] })}>
      <div className="relative h-14 max-sm:h-12">
        <input
          {...inputProps}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          id={id}
          className={classNames({
            cls: 'transition-bg peer bg-custom-surface-contrast-low h-full w-full rounded-xl border border-transparent px-3 py-2 pt-6 text-base duration-300 outline-none',
            mods: {
              '!border-status-errorSecondary bg-status-errorTertiary': !!error,
              'hover:bg-surface-base-inverse-tertiary focus:bg-surface-base-inverse-tertiary':
                !error,
            },
          })}
        />
        <label
          htmlFor={id}
          className={classNames({
            cls: 'text-text-base-secondary pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 cursor-text text-base tracking-[-0.01rem] transition-all duration-300 peer-focus:top-4',
            mods: {
              'top-4 text-sm leading-[18px]': isFocused || value,
            },
          })}
        >
          {label}
        </label>
      </div>
      {!!error?.message && (
        <span className="text-status-errorSecondary mt-1 block text-[12px] leading-[18px] font-normal">
          {error?.message}
        </span>
      )}
    </div>
  );
};
